import React from 'react';
import {Link} from 'react-router-dom';

import Avatar from '../../../components/Avatar';
import DateSince from "../../../components/Date";
import createLink from "../../../../libs/createLink";

import _ from "lodash";


const CardLastTopics = (props) => {
    let lastPost = {
        ...props.lastComment,
        owner: props.lastComment.owner ? props.lastComment.owner : props.authorName
    };
    let totalPage = props.count ? Math.ceil(props.count.comment / 20) : 0;
    let hasOwner = props.owner !== null && props.owner._id;
    let lastPostHasOwner = lastPost.owner !== null && lastPost.owner._id;
    return (
            <div className="card-subcategory">
                <div className="wrapper-left">
                    <div className="wrapper-card-subcategory">
                        <div className="wrapper-title">
                            <div className="title">
                                <div className="before-title responsive-hidden-640">
                                    {!props.isApproved && (
                                        <span className="badge closed">Refusé</span>
                                    )}
                                    {!props.isOpened && (
                                        <span className="badge closed" title="Le modérateur interdit toute réponse sur ce sujet">Verrouillé</span>
                                    )}
                                    {props.isPinned && (
                                        <span className="badge pinned" title="Cette discussion est toujours affichée en premier">Épinglé</span>
                                    )}
                                    {props.isPoll && (
                                        <span className="badge poll">Sondage</span>
                                    )}
                                </div>
                                <Link
                                    to={createLink("forumTopic", {categoryParent : {slug : _.get(props,"match.params.slugParent") || ""}, category : {slug : _.get(props,"forum.slug") || "", "_id" : _.get(props,"forum._id")}, topic : {"_id" : _.get(props,"_id"), slug : _.get(props,"slug") || ""}}) }>{props.title.length >= 55 ? props.title.substring(0, 55) + "..." : props.title} </Link>
                            </div>
                            <div className="row align-center started-by">Débuté par&nbsp;
                                {hasOwner ? <Link className={"username"} to={createLink("userProfile", props.owner)}>
                                        {props.owner.username}
                                    </Link> :
                                    <div>{props.authorName}</div>}
                                ,&nbsp;{props.createdAt ?
                                    <DateSince
                                        date={props.createdAt}
                                        prefix={true}
                                        currentFormat={true}
                                    />
                                    : ''}
                            </div>
                            <div className="row align-center started-by mt-4">Dans &nbsp;
                                <Link className="title-forum" to={createLink("forumCategory", {category : {slug : props.forum.slug, _id : props.forum._id}})}>{props.forum && props.forum.name}</Link>
                            </div>
                        </div>
                        <div className="wrapper-infos">
                            <div className="subjects"><span>{props.count && props.count.view}</span>&nbsp;vues
                            </div>
                            <div className="answers">
                                <span>{props.count && (props.count.comment || 0)}</span>&nbsp;réponses
                            </div>
                        </div>
                    </div>
                </div>
                {lastPostHasOwner? (
                    <div className="last-post full">
                        <Link to={createLink("userProfile", lastPost.owner)}><Avatar
                            avatar={lastPost.owner.profile.avatar} gender={lastPost.owner.profile.gender}
                            alt=""/></Link>
                        <div className="wrapper-infos-last">
                            <Link className="link" to={createLink("forumTopic", {categoryParent : {slug : _.get(props,"match.params.slugParent") || ""}, category : {slug : _.get(props,"forum.slug") || "", "_id" : _.get(props,"forum._id")}, topic : {"_id" : _.get(props,"_id"), slug : _.get(props,"slug") || "", page : totalPage}}) + '#last-comment' }>
                                <span>Dernier message </span>
                                <span>par {lastPost.owner.username && lastPost.owner.username.length >= 15 ? lastPost.owner.username.substring(0, 15) + "..." : lastPost.owner.username}</span>
                            </Link>
                            <div className="text small medium-grey">
                                {lastPost.createdAt ? <DateSince
                                    date={lastPost.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                /> : 0}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="last-post full">
                        <Avatar gender="guest" alt=""/>
                        <div className="wrapper-infos-last">
                            <div className="username-last-post">Par
                                Guest_{lastPost.authorName && lastPost.authorName.length >= 10 ? lastPost.authorName.substring(0, 10) + "..." : lastPost.authorName}</div>
                            <div
                                className="text small medium-grey">
                                {lastPost.createdAt ? <DateSince
                                    date={lastPost.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                /> : 0}
                            </div>
                        </div>
                    </div>
                )}
            </div>
    )

}


CardLastTopics.defaultProps = {
    allowed: false,
    slug: '',
    title: '',
    authorName: '',
    description: '',
    createdAt: '',
    redirect: {
        url: ''
    },
    lastComment: {
        createdAt: 0,
        authorName: '',
        owner: {
            username: '',
            avatar: '',
            slug: '',
            gender: 3,
        }
    },
    owner: {
        slug: '',
        username: '',
        avatar: '',
    }

};


export default CardLastTopics;
